import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initSentry } from './sentry.js'
import App from './App.jsx'
import { ThemeProvider } from './theme.jsx'
import './i18n.js'
import './index.css'
// Must be imported before React mounts so beforeinstallprompt is never missed
import './pwaInstall.js'
import { registerSW } from 'virtual:pwa-register'

initSentry()

// Registrera SW och kolla efter uppdateringar var 15:e minut
registerSW({
  onRegisteredSW(swUrl, registration) {
    setInterval(() => registration?.update(), 15 * 60 * 1000)
  },
})

if (window.location.hostname.startsWith('www.')) {
  window.location.replace(window.location.href.replace('://www.', '://'))
} else {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>
  )
}
